(function () {
  var STORAGE_KEY = 'dvergarnir-project-type';
  var DEFAULT_TYPE = 'solpallur';
  var current = DEFAULT_TYPE;

  function normalizeType(type) {
    return type === 'skjolveggur' ? 'skjolveggur' : 'solpallur';
  }

  function matchesType(el, type) {
    var types = (el.getAttribute('data-project-types') || 'solpallur,skjolveggur').split(',');
    return types.indexOf(type) !== -1;
  }

  function setActiveButtons(type) {
    document.querySelectorAll('[data-dverg-project-type-btn]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-dverg-project-type-btn') === type;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updateLabels(type) {
    document.querySelectorAll('[data-dverg-project-label]').forEach(function (el) {
      var label = el.getAttribute('data-dverg-project-label-' + type);
      if (label) el.textContent = label;
    });

    document.querySelectorAll('[data-dverg-project-desc]').forEach(function (el) {
      var desc = el.getAttribute('data-dverg-project-desc-' + type);
      if (desc) el.textContent = desc;
    });
  }

  function filterElements(type) {
    document.querySelectorAll('[data-project-types]').forEach(function (el) {
      el.classList.toggle('dverg-project-hidden', !matchesType(el, type));
    });
  }

  function apply(type, persist) {
    current = normalizeType(type);
    if (persist !== false) {
      try {
        localStorage.setItem(STORAGE_KEY, current);
      } catch (e) {}
    }

    document.documentElement.setAttribute('data-dvergarnir-project', current);
    setActiveButtons(current);
    updateLabels(current);
    filterElements(current);

    document.dispatchEvent(
      new CustomEvent('dvergarnir:project-type-change', {
        bubbles: true,
        detail: { type: current }
      })
    );
  }

  function initButtons() {
    document.querySelectorAll('[data-dverg-project-type-btn]').forEach(function (btn) {
      if (btn.dataset.dvergProjectBound === 'true') return;
      btn.dataset.dvergProjectBound = 'true';
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-dverg-project-type-btn'));
      });
    });
  }

  function init() {
    var stored = DEFAULT_TYPE;
    try {
      stored = localStorage.getItem(STORAGE_KEY) || DEFAULT_TYPE;
    } catch (e) {}

    initButtons();
    apply(stored, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.DvergarnirProjectType = {
    apply: apply,
    get: function () {
      return current;
    }
  };
})();
